import React from 'react'
import "../Assets/styles/project.css"
import one from "../Assets/images/homepage_project1_jpg.png"
import two from "../Assets/images/homepage_project2_jpg.png"
import three from "../Assets/images/homepage_project3_jpg.png"
import four from "../Assets/images/homepage_project4_jpg.png"
import five from "../Assets/images/homepage_project5_jpg.png"
import six from "../Assets/images/homepage_project6_jpg.png"
import seven from "../Assets/images/homepage_project7_jpg.png"

const Project = () => {
  return (
    <>
        <div className="container-lg">
            <div className="header" data-aos="fade-right" data-aos-duration="1000">
                <span>Projects</span> 
                <h3>Our Portfolio</h3>
            </div>
            {/* <div className="title">
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incidiunt labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida.</p>
            </div> */}
            <div className="row">
                <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-duration="1000">
                    <div className="single-projects">
                        <div className="projects-image">
                            <img src={one} alt="ifmage"/>
                        </div>
                        <div className="projects-content">
                            <a href="/">
                                <h3>App Update &amp;Rebrand</h3>
                            </a>
                            <a href="/">
                                <span>Research and startup</span>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-duration="1000">
                    <div className="single-projects">
                        <div className="projects-image">
                            <img src={two} alt="ige"/>
                        </div>
                        <div className="projects-content">
                            <a href="/">
                                <h3>IT Consultancy</h3>
                            </a>
                            <a href="/">
                                <span>Research and startup</span>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4" data-aos="fade-up" data-aos-duration="1000">
                    <div className="single-projects">
                        <div className="projects-image">
                            <img src={three} alt="igh"/>
                        </div>
                        <div className="projects-content">
                            <a href="/">
                                <h3>Digital Marketing</h3>
                            </a>
                            <a href="/">
                                <span>Research and startup</span>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4" data-aos="fade-up" data-aos-duration="1000">
                    <div className="single-projects">
                        <div className="projects-image">
                            <img src={four} alt="im"/>
                        </div>
                        <div className="projects-content">
                            <a href="/">
                                <h3>App Development</h3>
                            </a>
                            <a href="/">
                                <span>Research and startup</span>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-duration="1000">
                    <div className="single-projects">
                        <div className="projects-image">
                            <img src={five} alt="imh"/>
                        </div>
                        <div className="projects-content">
                            <a href="/">
                                <h3>IT Solutions</h3>
                            </a>
                            <a href="/">
                                <span>Research and startup</span>
                            </a>
                        </div>
                    </div>
                    <div className="single-projects">
                        <div className="projects-image">
                            <img src={six} alt="imh"/>
                        </div>
                        <div className="projects-content">
                            <a href="/">
                                <h3>Data Management</h3>
                            </a>
                            <a href="/">
                                <span>Research and startup</span>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-duration="1000">
                    <div className="single-projects">
                        <div className="projects-image">
                            <img src={seven} alt="ima"/>
                        </div>
                        <div className="projects-content">
                            <a href="/">
                                <h3>E-commerce Development</h3>
                            </a>
                            <a href="/">
                                <span>Research and startup</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}

export default Project